import { render, staticRenderFns } from "./TakeExam.vue?vue&type=template&id=424c6e31&scoped=true"
import script from "./TakeExam.vue?vue&type=script&lang=js"
export * from "./TakeExam.vue?vue&type=script&lang=js"
import style0 from "./TakeExam.vue?vue&type=style&index=0&id=424c6e31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c6e31",
  null
  
)

export default component.exports